import { render, staticRenderFns } from "./BlwCalendar.vue?vue&type=template&id=21dd985c&"
import script from "./BlwCalendar.vue?vue&type=script&lang=js&"
export * from "./BlwCalendar.vue?vue&type=script&lang=js&"
import style0 from "./BlwCalendar.vue?vue&type=style&index=0&id=21dd985c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports